// extracted by mini-css-extract-plugin
export default {"recurring":"RecurringPayment_recurring__tCP5F"};